// src/config/shopConfig.js
export const shopConfig = {
  locale: window.Shopify?.locale || navigator.language || 'en-US',
  currency: window.Shopify?.currency?.active || 'USD',
};
